import { cloneDeep, times } from 'lodash';
import createTaskType from '../../createTaskType';
import SceneCreationEditor from './Editor';

export default createTaskType({
    id: 'scene_creation',
    label: 'Story Scene',
    skill: 'listening',
    v2: true,
    hasRubric: true,

    editor: SceneCreationEditor,
    createItemsTemplate: () => times(6, index => ({
        is_example: index === 0,
        question: null,
        // Only example has rubric
    ...(index === 0 && {
            rubric_id: ''
    }),

        audio_id: null,
        answers: times(3, index => ({
            is_correct_answer: false,
            image_id: '',
        })),
    })),

    convertToUploadFormat(task, { isNew }) {
        task = cloneDeep(task);


        task.items = task.items.map(i => {
            i.answers = i.answers.map(a => {
                delete a.coordinates;
                return a;
            });
            return i;
        });

        return task;
    },

    backgroundImages: {
        count: 2,
        description: 'Two background images are present in the Story Scene task, one for the example that sets the scene, one for the actual task.',
        configs: [
            {
                label: 'Example Background (context image)',
                helperText: 'Only seen before and during the example.'
            },
            {
                label: 'Main task background',
                helperText: 'Seen behind all items.'
            },
        ],
    },

    getKeys: (item) => {
        return item.answers
            .filter(x => x.is_correct_answer)
            .map(x => `Option ${'ABC'[x.order - 1]} - ${x.image_id}`);
    }
});